import DownloadIcon from '@mui/icons-material/Download';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import './Hero.css';

const Hero = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = portfolioData.cvPath;
    link.download = 'Abrham-Tesfaye-CV.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="hero" id="top" aria-label="Introduction">
      <div className="hero__media" aria-hidden="true">
        <img
          src={require('../../assets/images/profile.jpg')}
          alt=""
          className="hero__photo"
        />
        <div className="hero__media-veil" />
      </div>

      <div className="container hero__content">
        <Reveal>
          <p className="hero__eyebrow">{portfolioData.location}</p>
        </Reveal>

        <Reveal delay={1}>
          <h1 className="hero__name">
            <span>{portfolioData.firstName}</span>
            <span>{portfolioData.lastName}</span>
          </h1>
        </Reveal>

        <Reveal delay={2}>
          <p className="hero__role">{portfolioData.profession}</p>
          <p className="hero__tagline">{portfolioData.tagline}</p>
        </Reveal>

        <Reveal delay={3}>
          <div className="hero__actions">
            <a className="btn btn-primary" href="#projects">
              View projects
              <ArrowDownwardIcon fontSize="small" />
            </a>
            <button type="button" className="btn btn-ghost" onClick={handleDownload}>
              Download CV
              <DownloadIcon fontSize="small" />
            </button>
          </div>

          <div className="hero__socials">
            {portfolioData.socials.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.id}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                >
                  <Icon fontSize="small" />
                </a>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
